import setIn from 'transmute/setIn';
export default setIn;